import FieldLabel from './ui/FieldLabel'
import Button from './ui/Button'
import { useRef, useState } from 'react'
import SignatureCanvas from 'react-signature-canvas'
import ModalComponent from './Modal'

export default function WorkerSignatureInput({ value, onChange, disabled }) {
    const [open, setOpen] = useState(false)
    const [signed, setSigned] = useState(false)
    const canvas = useRef(null)
    return <div>
        <FieldLabel className='fieldLabel'>Supervisor Signature</FieldLabel>
        {value && <img src={value} alt='Supervisor signature' style={{ maxWidth: '100%', height: 160, objectFit: 'contain' }} />}
        {!disabled && <Button data-action-tone="edit" variant={value ? 'secondary' : 'create'} size="md"  type='button' className='secondaryButton' onClick={() => { setSigned(false); setOpen(true) }}>{value ? 'Edit Signature' : 'Add Signature'}</Button>}
        <ModalComponent showModal={open} setShowModal={setOpen} customOverlayStyle={{ zIndex: 1500 }} customContentStyle={{ boxSizing: 'border-box', minWidth: 0, width: 'calc(100vw - 24px)', padding: 16 }}>
            <h2 className='modalTitle'>Supervisor Signature</h2>
            <SignatureCanvas ref={canvas} onEnd={() => setSigned(!canvas.current.isEmpty())} canvasProps={{ width: Math.min(440, window.innerWidth -  60), height: 180, style: { touchAction: 'none', border: '1px solid #d7dfea' }, 'aria-label': 'Draw supervisor signature' }} />
            <div className='modalFooter' style={{ flexWrap: 'wrap' }}>
                <Button variant="secondary" size="md" type='button' className='secondaryButton' onClick={() => { canvas.current.clear(); setSigned(false) }}>Clear</Button>
                <Button data-action-tone="cancel" variant="secondary" size="md"  type='button' className='secondaryButton' onClick={() => setOpen(false)}>Cancel</Button>
                <Button variant="secondary" size="md" type='button' className='saveWithIcon' disabled={!signed} onClick={() => { onChange(canvas.current.getCanvas().toDataURL('image/png')); setOpen(false) }}>Use Signature</Button>
            </div>
        </ModalComponent>
    </div>
}
